import React from "react";

export default function RoleWidgetMobile(props) {
  return <div className="role-widget-mobile">{props.role}</div>;
}
